import React, { useState } from "react";
import NewNote from "../../Popups/NewNote";
import KendoClientDetailNote from "./KendoClientDetailNote";
import { CLIENT_SEARCH_FILTERS } from "../../../constants/clientSearchFilters";

const ClientNote = (props) => {
  const [popupNote, setPopupNote] = useState(false);
  const [Notetype, setNoteType] = useState("I");
  const HandleSetNote = () => {
    setPopupNote(false);
  };

  const TriggerNote = (check) => {
    setPopupNote(check);
  };

  const AlterNoteType = (e) => {
    const curVal = e.target.value;
    setNoteType(curVal);
  };

  return (
    <>
      {popupNote !== false ? (
        <NewNote type="create" parentCallback={HandleSetNote} />
      ) : (
        ""
      )}

      <div className="tab-pane" id="clientTask">
        <div role="tabpanel" className="tab-pane active" id="clientTask">
          <div className="table-panel task-table m-t-15">
            <div className="row table-panel-header">
              <div className="col-md-8 col-sm-8">
                <h6>Notes</h6>
              </div>
              <div className="col-md-4 col-sm-12">
                <div className="row flex-center-end row">
                  <div className="col-md-8 col-sm-8 progress-select">
                    <div className="field-container border-none flex-center-end">
                      <select
                        className="field-input w-20rem"
                        name="note"
                        value={Notetype}
                        onChange={(e) => AlterNoteType(e)}
                      >
                        {CLIENT_SEARCH_FILTERS.NOTE_TYPES.map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-4 flex-center-end">
                    <div className="popuop_open">
                      <span
                        className="popuop_button popupBtn"
                        role="button"
                        onClick={() => TriggerNote(true)}
                      >
                        Add
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-panel-body" id="gridWidth">
              <KendoClientDetailNote
                noteType={Notetype}
                clientId={props?.clientId}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ClientNote;
